import { reclaimActivationSurfaces } from "@redotech/redo-dispute-settings-common/reclaim-access-settings";
import * as z from "zod";

export const enableDisputes = {
  name: "enableDisputes" as const,
  input: z.object({
    /**
     * Present means "materialize commercial terms". Absent means access only —
     * the trial bootstrap and banner-dismiss paths depend on that.
     */
    activation: z
      .object({
        surface: z.enum(reclaimActivationSurfaces).optional(),
        /** Campaign link code (`?c=`), resolved server-side in the same call. */
        campaignCode: z.string().min(1).max(200).optional(),
      })
      .optional(),

    /**
     * @deprecated Compatibility shim for clients loaded before `activation`
     * shipped. Zod strips unknown keys, so an old tab calling with
     * `entrySource` would otherwise look like a deliberate access-only call and
     * silently skip materialization -- leaving a merchant who was quoted free
     * on a global trial that later bills. The server cannot tell an old client
     * from a genuine no-materialize call, so the alias has to be explicit.
     *
     * Remove one release after this ships.
     */
    entrySource: z.string().min(1).max(100).optional(),
    /** @deprecated Old top-level form; use `activation.campaignCode`. */
    campaignCode: z.string().min(1).max(200).optional(),
  }),
  output: z.object({
    status: z.enum([
      "trial_started",
      "trial_already_active",
      "billing_already_enabled",
      "free_access_enabled",
      "billing_required",
    ]),
  }),
};
